import React from 'react'
import { Table } from "semantic-ui-react"
import { RefundField } from './InvoiceTab'
import { displayCurrency } from '../../../utils/utils'
import { sortByAttr } from '../../../helpers/arrayHelpers'

function Row({a}) {
  return <Table.Row>
            <Table.Cell>{a.braintree_customer_id || a.external_account_ref}</Table.Cell>
            <Table.Cell>{a.braintree_transaction_id || a.external_transaction_id}</Table.Cell>
            <Table.Cell>{a.activity_type}</Table.Cell>
            <Table.Cell>{displayCurrency(a.amount)}</Table.Cell>
            <Table.Cell>{a.created_at}</Table.Cell>
         </Table.Row>
}

export default function TransactionsTab({order, handleRefund}) {
  let activities =
    order.braintree_activities.length > 0 ? order.braintree_activities :
    order.wex_activities.length > 0 ? order.wex_activities :
    order.ach_activities.length > 0 ? order.ach_activities :
    order.fleetcor_activities;
  activities = sortByAttr(activities, 'created_at')
  const ppType = order.payment_provider_type
  const typeStr = ppType ? `${ppType} ` : ''

  return <React.Fragment>
            {activities.length === 0 && (
              <div>
                <em>
                  {`No ${typeStr}transactions recorded. This may be a legacy order, or one that hasn't paid yet.`}
                </em>
              </div>
            )}
            {activities.length !== 0 && (
              <React.Fragment>
                <RefundField allowSendText refund={0} handleRefund={handleRefund} orderId={order.id} />
                <div style={{paddingTop: '10px'}}>
                  <strong>Payment Provider: </strong>{ppType}
                </div>
                <Table
                  striped
                  celled
                  selectable
                  style={{ marginTop: "1em", marginBottom: "5px" }}
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Customer ID</Table.HeaderCell>
                      <Table.HeaderCell>Txn Id</Table.HeaderCell>
                      <Table.HeaderCell>Activity Type</Table.HeaderCell>
                      <Table.HeaderCell>Amount</Table.HeaderCell>
                      <Table.HeaderCell>Created At (UTC)</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {activities.map(a => <Row a={a} />)}
                  </Table.Body>
                </Table>
                <div style={{paddingTop: '10px'}}><strong>Total collected:</strong> {displayCurrency(order.previous_payments)}</div>
              </React.Fragment>
            )}
          </React.Fragment>
}
